import React, { useEffect, useState } from "react";
import CustomTable from '../Table'
import LoadingCircular from '../../../loader/LoadingCircular';
import { getAllData } from "../../../Utils/firebaseServices";

function Careers() {
  const [carrers_data, setCarrers_data] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("carrers", setCarrers_data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) {
    return <LoadingCircular />;
  }
  return (
    <>
      <CustomTable
        data={carrers_data}
        coll={["Name", "Email", "Phone", "File"]}
      />
    </>
  )
}

export default Careers